import 'core-js/stable'
import 'regenerator-runtime/runtime'
import '../src/util/define_window_stimulus'
import '../src/site/controllers'
import '../src/util/install_sentry_with_performance'
import 'lazysizes'
import saveUtmParamsToCookie from '../src/saveUtmParamsToCookie'
import attachUtmParamsToLinks, { observeAndAttachUtmParams } from '../src/attachUtmParamsToLinks'

// ページのファーストビューに表示される重要なコンポーネントは直接インポート
import 'Components/nurikae/header/component'
import 'Components/nurikae/header/sp/component'
import 'Components/nurikae/footer/component'

// 遅延読み込み可能なコンポーネント
const lazyLoadCommonComponents = () => {
  import(/* webpackChunkName: "common-ui" */ 'Components/nurikae/scroll_to_top_button/component')
  import(/* webpackChunkName: "common-ui" */ 'Components/nurikae/breadcrumb/component')
}

// DOM読み込み後に実行
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(lazyLoadCommonComponents, 100)
    attachUtmParamsToLinks()
    observeAndAttachUtmParams()
  })
} else {
  setTimeout(lazyLoadCommonComponents, 100)
  attachUtmParamsToLinks()
  observeAndAttachUtmParams()
}

saveUtmParamsToCookie()
